import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

import "./styles.scss";

import { AppContext } from "../../contexts/AppContext";
import { IframeMessageProxy } from "iframe-message-proxy";
import Iframe from "../Iframe";

export default function PluginIframe({
    url
}) {
    const { t } = useContext(AppContext);
    const history = useHistory();
    const iframeRef = useRef(null);
    const [customTab, setCustomTab] = useState(null);

    // -----------------------------
    // QUERY PARAMS (useLocation precisa ser fora de função)
    // -----------------------------
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    // -----------------------------
    // 1. OUVIR MENSAGENS DO FILTRO (N2)
    // -----------------------------
    useEffect(() => {
        async function onMessage(event) {
            let id;
            let payload;
            try {
                const msg = event.data;

                id = msg.trackingProperties?.id

                // if (!msg || msg.source !== "filtro") return;

                // console.log("DEBUG TESTE", msg, event);

                if (event?.data?.message) {
                    console.log("DEBUG MSG", msg, event, msg.trackingProperties?.id);

                    payload = {
                        ...event?.data?.message,
                        action: event?.data?.message?.action?.split(":")?.[1]
                    }

                    let result = await IframeMessageProxy.sendMessage(payload);
                    console.log("dEBUG RESULT", result, msg.trackingProperties)
                    sendToChild(
                        {
                            response: result.response
                        },
                        msg.trackingProperties
                    )
                } else if (event?.data?.response) {
                    console.log("DEBUG RESPONSE", event)
                }

                // aqui você pode disparar estados, abrir abas etc.
            } catch (error) {
                console.error("DEBUG ERROR", { id, payload }, error)
            }
        }

        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, []);

    // -----------------------------
    // 2. ENVIAR MENSAGENS PARA O FILTRO (N2)
    // -----------------------------
    function sendToChild(message, trackingProperties) {
        let payload = {
            ...message,
            trackingProperties
        }

        console.log("sendToChild payload", payload, payload?.trackingProperties?.id)

        if (!iframeRef.current) return;

        iframeRef.current.contentWindow.postMessage(payload,
            // {
            //     // source: "pai", // mantém para N2 identificar
            //     ...data
            // },
            "*" // 👉 se quiser posso travar para um domínio específico
        );

        // console.log("N1 (Pai) → N2 (Filtro):", { action, content });
    }

    return (
        <div
            className="flex"
            style={{
                height: "100vh",
                overflowX: "auto",
                backgroundColor: query.get("backgroundColor") || "#fff"
            }}
        >
            <Iframe
                iframeRef={iframeRef}
                url={url}
            />
        </div>
    );
}
